<template>
  <div class="overlay-news">
    <div class="overlay-body">
      <div class="content">
        <div class="border-grid"></div>
        <h3 class="title" v-html="$t('message.cookie_title')"></h3>
        <p class="text" v-html="$t('message.cookie_text')"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cookie",
  props: ["isOpenOverlay", "toggleOpenOverlay", "indexNews"],
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.overlay-news {
  position: relative;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .overlay-body {
    position: relative;
    top: 70px;

    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
  }
}
.border-grid {
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: none;
  border-left: 1px solid rgba($color: #000000, $alpha: 0.05);
  border-right: 1px solid rgba($color: #000000, $alpha: 0.05);
  .inner-line {
    display: none;
    position: absolute;
    left: 50%;
    height: 100%;
    border-left: 1px solid rgba($color: #000000, $alpha: 0.05);
  }
}
.content {
  position: relative;
  margin: 0 25%;
  @media screen and( max-width: 1100px) {
    margin: 0 15%;
  }
  @media screen and( max-width: 900px) {
    margin: 0 20px;
  }
  h3 {
    padding-top: 75px;
    font-size: 60px;
    line-height: 74px;
    font-weight: 700;
    margin-bottom: 30px;
    @media screen and (max-width: 1100px) {
      line-height: 50px;
      font-size: 40px;
    }
    @media screen and (max-width: 900px) {
      line-height: 37px;
      font-size: 30px;
    }
  }
  p {
    font-size: 16px;
    line-height: 30px;
  }
  p.subtitle {
    font-style: italic;
    margin-bottom: 100px;
    @media screen and (max-width: 900px) {
      margin-bottom: 50px;
    }
  }
}
.download {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 70px 0 150px;
  cursor: pointer;
  img {
    width: 20px;
  }
  p {
    text-decoration: underline;
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// Cookie.vue?c2fe63ce